import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
// import moment from 'moment';
// import moment from 'moment-timezone'

/**
 * Generated class for the CalendarPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-calendar',
  templateUrl: 'calendar.html',
})
export class CalendarPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController) {
  }

  ionViewDidLoad() {
    
  }

  dateSelected(date){
    // console.log('inside dateSelected');
    // console.log(date)
    // var dd = moment.tz(date, 'DD/MM/YY h:m A', 'Australia/Melbourne');
    // var dd = moment(date).tz('Australia/Melbourne').format('DD-MM-YYYY hh:mm A')
    // console.log(dd)
    // var d = moment(new Date(date)).format('DD-MM-YYYY');
    // var d = moment(new Date(date)).format('YYYY-MM-DD');
    // var d = moment(new Date(date)).format('YYYY-MM-DD[T]hh:mm:ss.SSS[Z]');
    this.viewCtrl.dismiss({date: date, dismiss:'cancel'});
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/calendar/calendar.ts